export default __webpack_public_path__ + "static/media/discord3.28cb5d2f.svg";